import { render, staticRenderFns } from "./addUpdateDialog.vue?vue&type=template&id=6c3c4e6e&"
import script from "./addUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./addUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c3c4e6e')) {
      api.createRecord('6c3c4e6e', component.options)
    } else {
      api.reload('6c3c4e6e', component.options)
    }
    module.hot.accept("./addUpdateDialog.vue?vue&type=template&id=6c3c4e6e&", function () {
      api.rerender('6c3c4e6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sourceUrl/components/addUpdateDialog.vue"
export default component.exports